// extracted by mini-css-extract-plugin
module.exports = {"footer":"CoFooter_footer__2-KaR"};